import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import EducationMaterialAutocomplete from './EducationMaterialAutocomplete';

loadDOMComponent({
	selector: 'react-education-material-autocomplete',
	callback: ({ container }) => {
		const inputPlaceholder = container.getAttribute('placeholder');
		const targetHiddenId = container.getAttribute('data-target-hidden-id');

		const handleChange = value => {
			if (targetHiddenId) {
				const element = document.querySelector(
					"[data-hidden-id='" + targetHiddenId + "']",
				);

				// @ts-ignore
				element.value = value.map(v => v.id).join(',');
			}
		};

		ReactDOM.render(
			<AppContextProvider>
				<EducationMaterialAutocomplete
					onChange={handleChange}
					placeholder={inputPlaceholder}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
